module.exports = require('./lib/index');



/** WEBPACK FOOTER **
 ** ./src/app/modules/login/~/redux/~/symbol-observable/index.js
 **/